module.exports = __webpack_public_path__ + "static/media/stroopwafel.cc5191b7.svg";